module.exports = __webpack_public_path__ + "assets/assets/images/icons/icon-phone.12f23d33.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/icon-phone.svg
// module id = 338
// module chunks = 2